import { logError } from '@/lib/logger';

export const READINESS_RESPONSES_PATH =
  '/api/v1.0/public/pet-loss-readiness/responses';

export async function saveReadinessResponse(input: {
  partnerSlug?: string | null;
  answers: Record<string, string>;
}): Promise<boolean> {
  try {
    const response = await fetch(READINESS_RESPONSES_PATH, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        partnerSlug: input.partnerSlug ?? null,
        answers: input.answers,
        consent: true
      })
    });
    if (!response.ok) {
      logError('[saveReadinessResponse] Answers were not saved', undefined, {
        status: response.status
      });
    }
    return response.ok;
  } catch (error) {
    logError('[saveReadinessResponse] Answers were not saved', error);
    return false;
  }
}
